module.exports = __webpack_public_path__ + "img/img62.8bd3a1ba.png";